var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7cbcca307c57c821adbd4546bed79c63.svg#b';
                    var viewUrl = 'sprites.7cbcca307c57c821adbd4546bed79c63.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };